<mat-accordion
[multi]="true"
#accordion="matAccordion"
>

  <mat-expansion-panel 
  [disabled]="panel.isDisabled"
  [expanded]="panel.isExpanded"
  [hideToggle]="true"
  (opened)="beforePanelOpened(panel)"
  (closed)="beforePanelClosed(panel)"
  (afterCollapse)="afterPanelClosed($event)"
  (afterExpand)="afterPanelOpened($event)"

  *ngFor="let panel of accordionList"
  #mapanel="matExpansionPanel"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        
            <div class="row align-items-start">
                
                <div class="col-9"> 
                    <h4><mat-icon class="carta">alarm_on </mat-icon> {{panel.horaIni}} - {{panel.horaFin}}</h4>
                </div>  
                <div class="col-2">
                    <mat-slide-toggle [(ngModel)]="panel.estado" ></mat-slide-toggle>  
                </div>
                
                <div class="w-100"></div>
                <div>
                    <p> .La Alarma sonará {{selectedDisp1}} entre las  {{panel.horaIni}} - {{panel.horaFin}} durante más de 15min</p>
                </div>
               
            </div>        
      </mat-panel-title>
    </mat-expansion-panel-header>
                        <mat-form-field appearance="fill" class="select">
                            <mat-label>EVENTO</mat-label>
                            <mat-select [(value)]="selectedDisp1"[(ngModel)]="selectOpcion1" (ngModelChange)="OnOptionEvent1()">

                            <mat-option [value]="option.value" *ngFor="let option of opcionesDisp">{{ option.viewValue }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    
                   
                        <div class="timepicker">
                            <mat-form-field>
                                <mat-label>Hora Inicio</mat-label>
                                <input
                                    matInput
                                    placeholder=" Hora inicio"
                                    aria-label="Append to input"
                                    [ngxTimepicker]="horaInicial"
                                    [format]="24"
                                    [value]="panel.updateTimeIni"
                                 />
                                 <mat-icon matSuffix  (click)="horaInicial.open()">watch_later</mat-icon>
            
                                    <ngx-material-timepicker #horaInicial [appendToInput]="true" (timeSet)="onTimeIni($event, panel)">
                                    </ngx-material-timepicker>
                            </mat-form-field>
                        </div>
                        
                        <div class="timepicker">
                            <mat-form-field>
                                <mat-label>Hora final</mat-label>
                                <input
                                    matInput
                                    placeholder=" Hora final"
                                    aria-label="Append to input"
                                    [ngxTimepicker]="horaFinal"
                                    [format]="24"
                                    [value]="panel.updateTiemEnd"
                                 />
                                 <mat-icon matSuffix  (click)="horaFinal.open()"> watch_later</mat-icon>
            
                                    <ngx-material-timepicker #horaFinal [appendToInput]="true" (timeSet)="onTimeFin($event, panel)">
                                    </ngx-material-timepicker>
                            </mat-form-field>
                        </div>
    <mat-action-row>
        <button color="success" mat-flat-button (click)="save(panel, option)">Guardar</button>
        <button color="success" mat-flat-button (click)="mapanel.close()">Cerrar Ventana</button>
        <button color="danger" mat-flat-button  (click)="deleteData(panel)">Eliminar</button>
    </mat-action-row>
  </mat-expansion-panel>
</mat-accordion>


    <div class="button-container">
        <button mat-fab color="primary" aria-label="Añadir alarma" (click)="onAddAlarm()">
            <mat-icon>alarm_add</mat-icon>
        </button>
    <div>
